import React from "react";
import { Tooltip, Button, Dropdown } from "antd";
import { CompassOutlined } from "@ant-design/icons";

const AntdTourToggle = () => {
  const start = (type) => {
    window.dispatchEvent(
      new CustomEvent("start-onboarding", { detail: { type } })
    );
  };

  const items = [
    { key: "full", label: "Tour Completo", onClick: () => start("full") },
    {
      key: "projects",
      label: "Tour de Projetos",
      onClick: () => start("projects"),
    },
    {
      key: "syncs",
      label: "Tour de Sincronizações",
      onClick: () => start("syncs"),
    },
    {
      key: "reports",
      label: "Tour de Relatórios",
      onClick: () => start("reports"),
    },
    {
      key: "groups",
      label: "Tour de Agrupamento",
      onClick: () => start("groups"),
    },
    {
      key: "builder",
      label: "Tour do Builder",
      onClick: () => start("builder"),
    },
  ];

  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 1100 }}>
      {/* <Dropdown menu={{ items }} placement="topRight" trigger={["click"]}>
        <Tooltip title="Iniciar tour">
          <Button shape="circle" size="large" icon={<CompassOutlined />} />
        </Tooltip>
      </Dropdown> */}
    </div>
  );
};

export default AntdTourToggle;
